import { jsx } from "react/jsx-runtime";
import { Box, FieldSet, LabeledControl, Radio, Label, FormHelp, Legend } from "@zillow/constellation-10";
import PropTypes from "prop-types";
import React from "react";
import { useFormContext, useFormState } from "react-hook-form";
function RadioField({
  label,
  options,
  name,
  config,
  description,
  onChange,
  disabled,
  required
}) {
  var _a;
  const form = useFormContext();
  const proxyFormState = useFormState();
  const error = (_a = proxyFormState == null ? void 0 : proxyFormState.errors[name]) == null ? void 0 : _a.message;
  const field = form.register(name, config);
  return /* @__PURE__ */ jsx(Box, { css: {
    marginBottom: "tighter"
  }, children: /* @__PURE__ */ jsx(FieldSet, { legend: /* @__PURE__ */ jsx(Legend, { children: label }), description: /* @__PURE__ */ jsx(FormHelp, { children: error || description || /* @__PURE__ */ jsx(React.Fragment, { children: " " }) }), disabled, required, error: Boolean(error), children: options && options.map((option) => /* @__PURE__ */ jsx(LabeledControl, { label: /* @__PURE__ */ jsx(Label, { children: option.label }), control: /* @__PURE__ */ jsx(Radio, { ...field, value: option.value, onChange: (e) => {
    field.onChange(e);
    onChange == null ? void 0 : onChange(e);
  } }) }, option.label)) }) });
}
RadioField.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.node,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  config: PropTypes.shape({
    required: PropTypes.string,
    validate: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func])
  }),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired
};
RadioField.defaultProps = {
  description: void 0,
  config: void 0,
  disabled: void 0,
  required: false,
  onChange: () => ({})
};
export {
  RadioField as default
};
